import styled from 'styled-components';

import { color } from 'theme/selectors';

export const StoreBtn = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    background-color: ${color('on-primary')};
    border-radius: ${({ theme }) => `${theme['border-radius-medium']}px`};
`;

export const AppleStoreImg = styled.img`
    height: 45px;
`;

export const GooglePlayMarketImg = styled.img`
    height: 32px;
`;
